

export function numberToWords(number: number): string {

    const ones: string[] = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens: string[] = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens: string[] = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    function convertBelowHundred(num: number): string {
        if (!num) {
            return 'invalid input';
        } 
        if (num < 10) {
            return ones[num];
        } else if (num < 20 && num >= 11) {
            return teens[num - 11];
        } else {
            const digit = num % 10;
            const ten = Math.floor(num / 10);
            return tens[ten] + (digit !== 0 ? ' ' + ones[digit] : '');
        }
    }

    function convertBelowThousand(num: number): string {
        const hundred = Math.floor(num / 100);
        const belowHundred = num % 100;

        if(!number) {
            return '';
        }

        if (hundred !== 0) {
            return ones[hundred] + ' Hundred' + (belowHundred !== 0 ? ' ' + convertBelowHundred(belowHundred) : '');
        } else {
            return convertBelowHundred(belowHundred);
        }
    }

    if (number === 0) {
        return ones[0];
    } else if (number < 0) {
        return 'Negative ' + numberToWords(-number);
    } else {
        let result = '';
        const billion = Math.floor(number / 1000000000);
        const million = Math.floor((number % 1000000000) / 1000000);
        const thousand = Math.floor((number % 1000000) / 1000);
        const remainder = number % 1000;

        if (billion !== 0) {
            result += convertBelowThousand(billion) + ' Billion';
        }

        if (million !== 0) {
            if (result.length > 0) {
                result += ' ';
            }
            result += convertBelowThousand(million) + ' Million';
        }

        if (thousand !== 0) {
            if (result.length > 0) {
                result += ' ';
            }
            result += convertBelowThousand(thousand) + ' Thousand';
        }

        if (remainder !== 0) {
            if (result.length > 0) {
                result += ' ';
            }
            result += convertBelowThousand(remainder);
        }
        if(!number) {
            result = '';
        }

        return result;
    }
}

// Example usage:
// const number: number = 123456789;
// const words: string = numberToWords(number);
// console.log(words);
